module.exports = __webpack_public_path__ + "static/media/house-night.4bc9383e.svg";